import { createMuiTheme } from '@material-ui/core/styles'

const theme = createMuiTheme({
  typography: {
    fontFamily: [
      'Montserrat',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(',')
  },
  palette: {
    primary: {
      // light: '#757ce8',
      main: '#30287b',
      // dark: '#30287b',
      contrastText: '#fff'
    },
    secondary: {
      // light: '#ece5fe',
      main: '#ece5fe',
      // dark: "#262061",
      contrastText: '#000'
    },
    yellow: '#fbbb33'
  }
})

export default theme
